exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn-danger[data-v-69e45b4d] {\n  color: white;\n}\n.center-block[data-v-69e45b4d] {\n  display: block;\n  margin-left: auto;\n  margin-right: auto\n}\n.subheader-img[data-v-69e45b4d] {\n  width: 150px; \n  margin: 0px auto 35px auto;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-69e45b4d","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/video-launcher/StethoscopeModal.vue
// module id = 2925
// module chunks = 29 66